export default __webpack_public_path__ + "static/media/pink-pencil-14.672c8bc1.svg";